import { useState, useEffect } from "react";

// material-ui
import LogoImage from "assets/logo/fractional/svg/multicolor/Step2.svg";
import { Box } from "@mui/material";
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = ({ size }) => {
 
  const [dimensions, setDimensions] = useState({ width: 40, height: 40 });

  useEffect(() => {
    if (size) {
      switch (size) {
        case "small":
          setDimensions({ width: 25, height: 25 });
          break;
        case "medium":
          setDimensions({ width: 40, height: 40 });
          break;
        case "large":
          setDimensions({ width: 60, height: 60 });
          break;
        default:
          setDimensions({ width: 40, height: 40 });
      }
    }
  }, [size]);

  return <Box component="img" src={LogoImage} sx={dimensions} />;
};

export default Logo;
